import { render, staticRenderFns } from "./ShowMemberNews.vue?vue&type=template&id=4260e915&scoped=true"
import script from "./ShowMemberNews.vue?vue&type=script&lang=js"
export * from "./ShowMemberNews.vue?vue&type=script&lang=js"
import style0 from "./ShowMemberNews.vue?vue&type=style&index=0&id=4260e915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260e915",
  null
  
)

export default component.exports